module.exports = __webpack_public_path__ + "static/27001-6bf67dcfe0963a176fb2ce24585d14c6.svg";